document.addEventListener('DOMContentLoaded', function () {
    // Select all buttons with the class 'button-link'
    const buttons = document.querySelectorAll('.nf-image-with-text-button');

    buttons.forEach(button => {
        // Get the href attribute of the button
        const link = button.getAttribute('href');

        // Get the closest .content-width ancestor to ensure only related images are affected
        const contentWidth = button.closest('.content-width');

        if (contentWidth) {
            // Select all images within this .content-width that have the class 'clickable-image'
            const images = contentWidth.querySelectorAll('.clickable-image');

            images.forEach(image => {
                // Wrap each image in an anchor tag with the button link
                const anchor = document.createElement('a');
                anchor.href = link;
                anchor.style.display = 'inline-block'; // Ensure the anchor displays as a block
                image.parentNode.insertBefore(anchor, image);
                anchor.appendChild(image);
               
            });
        }
    });
});